export default {
    'ERROR-JWT-TOKEN': {
        'NO-PROSPECT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Ce lien de connexion n'est plus valide.",
                en: 'This login link is no longer valid.',
            },
            redirectPath: '/',
        },
    },
};
